module.exports = __webpack_public_path__ + "img/shenfenzhengzhengmian@2x.c4c17a6f.png";